"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TextBlock = _interopRequireDefault(require("./TextBlock"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* Components should expect a content property with the main content to render
   and should be stateless */
var _default = {
  TextBlock: _TextBlock.default
};
exports.default = _default;